import { Observable } from '../lib/observable';

import type { OperatorLike } from '../types/observable-type';

function mapOperator<T, R = any>(mapFn: OperatorLike<T, R>) {
  return (source: Observable<T>) => {
    return new Observable<R>((observer) => {
      const { complete, error, next } = observer;

      //Promise.resolve(mapFn.call({}, value)).then((result) => next(result))

      source.subscribe(async (value: any) => next(await mapFn.call({}, value)), error, complete);
    });
  };
}

function filterOperator<T, R = any>(filterFn: OperatorLike<T, R>) {
  return (source: Observable<T>) => {
    return new Observable<T>((observer) => {
      const { complete, error, next } = observer;

      source.subscribe(async (value: T) => (await filterFn.call({}, value)) && next(value), error, complete);
    });
  };
}

function debounceOperator<T, R = undefined>(mapFn: OperatorLike<T, R>, delay = 0) {
  return (source: Observable<T>) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const debouncer = (fn: OperatorLike<T, R>, next: (value: R) => void) => {
      let timeout: NodeJS.Timeout;

      return (...args: [T]): void => {
        clearTimeout(timeout);

        timeout = setTimeout(async () => {
          next(await fn.call({}, ...args));
        }, delay);
      };
    };

    return new Observable<R>((observer) => {
      const { complete, error, next } = observer;
      const debounceFn = debouncer(mapFn, next);

      source.subscribe((value: any) => debounceFn(value), error, complete);
    });
  };
}

export { mapOperator, filterOperator, debounceOperator };
